import get from 'lodash/get';
import { Component, OnInit, Input } from '@angular/core';
import { IOrder, IOrderLine } from '@cakeiteasy/web-utils';
import { CART_LINE_TYPES } from '../../../cart';

@Component({
  standalone: false,
  selector: 'order-discount-tbody, tbody[order-discount-tbody]',
  templateUrl: './order-discount-tbody.component.html'
})
export class OrderDiscountTbodyComponent implements OnInit {
  @Input() order: IOrder;
  @Input() invoiceFeeOrderLine: IOrderLine;
  @Input() isCustomerView: boolean;

  public currency: string;
  public discountPrice: number;
  public CART_LINE_TYPES = CART_LINE_TYPES;

  ngOnInit(): void {
    this.discountPrice = this._getDiscountPrice();
    this.currency = get(this.order, 'bakery.country.currencySymbol');
  }


  private _getDiscountPrice(): number {
    const multiOrderLinesDiscount = () => {
      return this.order.multiOrder.orderLines
        .filter(({ type }) => type === CART_LINE_TYPES.DISCOUNT)
        .reduce((acc, { price }) => acc + price, 0) || 0;
    };
    const orderLinesDiscount = () => {
      return this.order.orderLines
        .filter(({ type }) => type === CART_LINE_TYPES.DISCOUNT)
        .reduce((acc, { price }) => acc + price, 0) || 0;
    };

    return this.isCustomerView
      ? orderLinesDiscount() || multiOrderLinesDiscount()
      : orderLinesDiscount();
  }
}
